/* Mummy & Munchkin — collection & search results: live filters, sort, load more, grid toggle, SEO toggle. */
(function () {
  'use strict';
  const root = document.querySelector('[data-mm-collection]');
  if (!root) return;
  const MM = window.MM || {};
  const sectionId = root.getAttribute('data-mm-section-id');
  const baseUrl = root.getAttribute('data-mm-url') || location.pathname;
  const form = root.querySelector('[data-mm-filter-form]');
  const results = root.querySelector('[data-mm-coll-results]');
  let controller = null;
  let debounce = null;

  /* ----- grid toggle (mobile) ----- */
  const grid = () => root.querySelector('[data-mm-coll-grid]');
  const applyCols = (n) => {
    const g = grid();
    if (g) g.classList.toggle('mm-grid--1', n === '1');
    root.querySelectorAll('[data-mm-cols]').forEach((b) => b.setAttribute('aria-pressed', b.getAttribute('data-mm-cols') === n ? 'true' : 'false'));
  };
  let cols = '2';
  try {
    cols = localStorage.getItem('mm-cols') || '2';
  } catch (e) {}
  applyCols(cols);
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mm-cols]');
    if (!b) return;
    cols = b.getAttribute('data-mm-cols');
    applyCols(cols);
    try {
      localStorage.setItem('mm-cols', cols);
    } catch (err) {}
  });

  /* ----- SEO read more ----- */
  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mm-seo-toggle]');
    if (!b) return;
    const body = b.parentElement.querySelector('.mm-coll__seo-body');
    const open = body.toggleAttribute('data-collapsed') === false;
    b.textContent = open ? 'Read less' : 'Read more';
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ----- fetch + swap ----- */
  function paramsFromForm() {
    const fd = new FormData(form);
    const params = new URLSearchParams();
    fd.forEach((v, k) => {
      if (v !== '' && v != null) params.append(k, v);
    });
    const q = new URLSearchParams(location.search).get('q');
    if (q && !params.has('q')) params.set('q', q);
    return params;
  }

  async function load(params, { push = true } = {}) {
    controller && controller.abort();
    controller = new AbortController();
    const query = params.toString();
    const url = baseUrl + (query ? '?' + query : '');
    results.classList.add('mm-is-loading');
    try {
      const res = await fetch(url + (query ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId), { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      swap(doc, '[data-mm-coll-results]');
      swap(doc, '[data-mm-coll-chips]');
      swap(doc, '[data-mm-coll-chips-mobile]');
      swap(doc, '[data-mm-filter-groups]');
      ['[data-mm-coll-count]', '[data-mm-active-count]', '[data-mm-results-count]', '[data-mm-sort-label]'].forEach((sel) => {
        const a = root.querySelector(sel);
        const b = doc.querySelector(sel);
        if (a && b) a.textContent = b.textContent;
      });
      const sortInput = form.querySelector('[data-mm-sort-input]');
      const sortVal = params.get('sort_by');
      if (sortInput) sortInput.value = sortVal || '';
      applyCols(cols);
      if (push) history.replaceState({}, '', url);
      document.dispatchEvent(new CustomEvent('mm:grid:update'));
    } catch (err) {
      if (err.name !== 'AbortError') console.warn('[mm-collection]', err);
    } finally {
      results.classList.remove('mm-is-loading');
    }
  }

  function swap(doc, sel) {
    const a = root.querySelector(sel);
    const b = doc.querySelector(sel);
    if (a && b) a.innerHTML = b.innerHTML;
  }

  /* ----- filters: live update on change, submit closes sheet ----- */
  if (form) {
    form.addEventListener('change', () => {
      clearTimeout(debounce);
      debounce = setTimeout(() => load(paramsFromForm()), 250);
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      clearTimeout(debounce);
      load(paramsFromForm());
      MM.drawer && MM.drawer.close('mm-filter-drawer');
    });
    root.addEventListener('click', (e) => {
      const clear = e.target.closest('[data-mm-clear-all]');
      if (!clear) return;
      e.preventDefault();
      form.querySelectorAll('input[type=checkbox]').forEach((i) => (i.checked = false));
      form.querySelectorAll('input[type=number]').forEach((i) => (i.value = ''));
      load(paramsFromForm());
    });
  }

  /* ----- active chips (remove) ----- */
  root.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-mm-chip]');
    if (!chip) return;
    e.preventDefault();
    const u = new URL(chip.getAttribute('href'), location.origin);
    load(u.searchParams);
  });

  /* ----- sort ----- */
  root.addEventListener('change', (e) => {
    const opt = e.target.closest('[data-mm-sort-opt]');
    if (!opt) return;
    const params = paramsFromForm();
    params.set('sort_by', opt.value);
    load(params);
    MM.drawer && MM.drawer.close('mm-sort-drawer');
  });

  /* ----- load more ----- */
  root.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-mm-load-more]');
    if (!btn) return;
    e.preventDefault();
    const next = new URL(btn.getAttribute('href'), location.origin);
    next.searchParams.set('section_id', sectionId);
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Loading…';
    try {
      const res = await fetch(next.toString());
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const g = grid();
      doc.querySelectorAll('[data-mm-coll-item]').forEach((item) => g.appendChild(item));
      const more = root.querySelector('[data-mm-coll-more]');
      const freshMore = doc.querySelector('[data-mm-coll-more]');
      if (more && freshMore) more.innerHTML = freshMore.innerHTML;
      const shown = root.querySelector('[data-mm-shown]');
      if (shown) shown.textContent = g.querySelectorAll('.mm-coll__item').length;
      const bar = root.querySelector('[data-mm-bar]');
      const total = parseInt((root.querySelector('.mm-coll__showing') || {}).textContent?.split('of')[1] || '0', 10);
      if (bar && total) bar.style.width = Math.min(100, (g.querySelectorAll('.mm-coll__item').length / total) * 100) + '%';
      document.dispatchEvent(new CustomEvent('mm:grid:update'));
    } catch (err) {
      btn.textContent = 'Load More';
      btn.removeAttribute('aria-busy');
    }
  });

  window.addEventListener('popstate', () => load(new URLSearchParams(location.search), { push: false }));
})();
